<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form
          class="login-form"
          ref="loginForm"
          :model="loginForm"
          :rules="loginFormRules"
        >
          <el-form-item prop="phone" label="手机号">
            <el-input
              v-model.trim="loginForm.phone"
              maxlength="11"
              placeholder="输入手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="sms" label="验证码">
            <el-input
              v-model.trim="loginForm.sms"
              placeholder="请输入短信验证码"
              id="code"
              maxLength="8"
            >
              <div
                slot="suffix"
                class="code-image"
                :class="disabled ? 'code-image-disable' : ''"
                @click="disabled ? '' : getMsg()"
              >
                {{ innerTxt }}
              </div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { updatePhone } from "../api";
import { changePhoneSms } from "@/views/login/api";
export default {
  name: "UpdatePhone",
  components: {
    DialogContainer,
  },
  data() {
    return {
      timer: null,
      disabled: false,
      innerTxt: "获取验证码",
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改手机号",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.savePhone = "";
          this.disabled = false;
          this.innerTxt = "获取验证码";
          clearInterval(this.timer);
          this.timer = null;
          this.loginForm = this.$options.data().loginForm;
          if (this.$refs.loginForm) this.$refs.loginForm.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      loginForm: {
        phone: "",
        sms: "",
      },
      loginFormRules: {
        sms: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: validatePhone, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    setTimer() {
      let time = 60;
      // 禁用按钮
      this.disabled = true;
      // 开启定时器
      this.timer = setInterval(() => {
        // 判断剩余时间
        if (time === 0) {
          // 清除定时器并复原按钮
          clearInterval(this.timer);
          this.disabled = false;
          this.innerTxt = `获取验证码`;
        } else {
          this.innerTxt = `${time}秒后可重新获取`;
          time--;
        }
      }, 1000);
    },
    // 判断是否需要验证码登录
    getMsg() {
      this.$refs.loginForm.validateField("phone", (valid) => {
        if (!valid) {
          changePhoneSms(this.loginForm.phone).then((res) => {
            if (res.code === 200) {
              this.setTimer();
            }
          });
        }
      });
    },
    init() {
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = Object.assign({}, this.loginForm);
          updatePhone(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("修改成功");
                this.$parent.getUserInfo();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.1rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    width: 1.6rem;
    color: #999999;
  }
}
</style>
